<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Bestelldokumente erstellen</v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-select
        v-if="praxen.length>1"
        v-model="praxis"
        :items="praxen"
        item-text="name"
        label="Allgemeine Informationen aus folgender Praxis übernehmen"
        required
        return-object
      ></v-select>
      <v-layout wrap>
        <v-flex xs12 md12 lg12 pa-1>
          <v-form ref="form" v-model="valid" lazy-validation>
            <h2>Allgemein</h2>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field v-model="documentData.ortName" label="Praxisname"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field v-model="documentData.ortAdresse1" label="1. Adresszeile"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field v-model="documentData.ortAdresse2" label="2. Adresszeile"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field v-model="documentData.ortTelefon" label="Telefonnummer"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field v-model="documentData.ortEmail" label="E-Mail Adresse"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.installDate"
                  label="Startdatum Softwarepflege"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-checkbox
                  v-model="documentData.ortErweiterterSupport"
                  label="Erweiterter Support"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-checkbox v-model="documentData.lizenzaenderung" label="Lizenzänderung"></v-checkbox>
              </v-flex>
            </v-layout>
            <h2>Bankdaten</h2>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field v-model="documentData.bankname" label="Bankname"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.iban"
                  label="IBAN"
                  :rules="[v => v === null ? false : v.length == 22 ||
              'Die IBAN muss 22 Zeichen lang sein']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field v-model="documentData.bic" label="BIC"></v-text-field>
              </v-flex>
            </v-layout>
            <h2>Preise für die Lizenzbestellung</h2>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.anzahlPraxen"
                  label="Anzahl Praxislizenzen"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.verkaufspreisOrt"
                  label="Einmaliger Lizenzpreis Praxislizenzen"
                  suffix="€"
                  @change="updateVerkaufspreisGesamt"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegePraxen"
                  label="Monatliche Softwarepflege Praxislizenzen"
                  suffix="€"
                  @change="updateMonatlicheGesamt"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.anzahlAerzte"
                  label="Anzahl Arztlizenzen"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.verkaufspreisAerzte"
                  label="Einmaliger Lizenzpreis Arztlizenzen"
                  suffix="€"
                  @change="updateVerkaufspreisGesamt"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegeAerzte"
                  label="Monatliche Softwarepflege Arztlizenzen"
                  suffix="€"
                  @change="updateMonatlicheGesamt"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.anzahlSelektivvertraege"
                  label="Anzahl Selektivvertragsverwaltung"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegeSelektivvertraege"
                  label="Monatliche Softwarepflege Selektivvertragsverwaltung"
                  suffix="€"
                  @change="updateMonatlicheGesamt"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.anzahlPruefmodule"
                  label="Anzahl Lizenzgebühr für externe Prüfmodule"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegePruefmodule"
                  label="Monatliche Softwarepflege Lizenzgebühr für externe Prüfmodule"
                  suffix="€"
                  :rules="preisRules"
                  @change="updateMonatlicheGesamt"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.verkaufspreisGesamt"
                  label="Einmaliger Lizenzpreis Gesamt"
                  suffix="€"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegeGesamtNeu"
                  label="Monatliche Softwarepflege Gesamt"
                  suffix="€"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <h2>Preise für den Softwarenutzungs- und Pflegevertrag der T2med GmbH & Co. KG</h2>
            <v-layout wrap>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegeNetto"
                  label="Monatliche Softwarepflege Gesamt Netto. Bitte beachten Sie bereits bestehenden SWP-Preise mit einzuberechnen."
                  suffix="€"
                  @change="computeMwst"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegeMwst"
                  label="Monatliche Softwarepflege Gesamt MwSt."
                  suffix="€"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="documentData.monatlicheSoftwarepflegeBrutto"
                  label="Monatliche Softwarepflege Gesamt Brutto"
                  suffix="€"
                  :rules="preisRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-spacer></v-spacer>
              <v-btn
                class="ma-2"
                color="primary"
                @click="createDocument"
              >Bestelldokument herunterladen</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
function trimObjectValues(obj) {
  if (obj !== undefined && obj !== null) {
    Object.keys(obj).map(k => {
      var value = obj[k];
      if (value !== undefined && value !== null && typeof value == "string") {
        obj[k] = value.trim();
      } else if (value !== undefined && value !== null) {
        trimObjectValues(value);
      }
    });
  }
}
export default {
  data() {
    return {
      praxis: null,
      valid: false,
      preisRules: [
        v =>
          v === undefined || v === null
            ? true
            : (v.length === 0 ? true : !isNaN(v.replace(",", "."))) ||
              "Es muss eine Zahl angegeben werden."
      ],
      documentData: {
        lizenzaenderung: false,
        ortName: "",
        ortAdresse1: "",
        ortAdresse2: "",
        ortTelefon: "",
        ortEmail: "",
        ortErweiterterSupport: null,
        installDate: "",
        bankname: "",
        iban: "",
        bic: "",
        anzahlPraxen: "0",
        anzahlAerzte: "0",
        anzahlSelektivvertraege: "0",
        anzahlPruefmodule: "0",
        verkaufspreisOrt: "0",
        verkaufspreisAerzte: "0",
        verkaufspreisGesamt: "0",
        monatlicheSoftwarepflegePraxen: "0",
        monatlicheSoftwarepflegeAerzte: "0",
        monatlicheSoftwarepflegeSelektivvertraege: "0",
        monatlicheSoftwarepflegePruefmodule: "0",
        monatlicheSoftwarepflegeGesamtNeu: "0",
        monatlicheSoftwarepflegeNetto: "0",
        monatlicheSoftwarepflegeMwst: "0",
        monatlicheSoftwarepflegeBrutto: "0"
      }
    };
  },
  computed: {
    ...mapState({
      praxen: state =>
        state.current.bestellung.lizenz.behandlungsorte.filter(
          ort => ort.hauptBehandlungsort
        ),
      lizenzaenderung: state => state.current.bestellung.lizenz.lizenzaenderung,
      geplantesInstallDate: state => state.current.bestellung.installDate
    })
  },
  watch: {
    praxen: function(nV) {
      if (nV.length == 1) {
        this.praxis = nV[0];
      }
    },
    praxis: function(nV) {
      this.documentData.ortName = nV.name;
      this.documentData.ortAdresse1 =
        nV.adresse.strasse + " " + nV.adresse.hausnummer;
      this.documentData.ortAdresse2 = nV.adresse.plz + " " + nV.adresse.ort;
      this.documentData.ortTelefon = nV.telefonNummer;
      if (nV.primaereEmailAdresse !== null) {
        if (nV.primaereEmailAdresse.email !== null) {
          this.documentData.ortEmail = nV.primaereEmailAdresse.email;
        }
      }
      this.documentData.ortErweiterterSupport = nV.erweiterterSupport;
      if (
        this.geplantesInstallDate !== null &&
        this.geplantesInstallDate !== undefined
      ) {
        const dateFormat = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        };
        this.documentData.installDate = new Date(
          this.geplantesInstallDate
        ).toLocaleDateString(navigator.language, dateFormat);
      }
    },
    lizenzaenderung: function(nV) {
      this.documentData.lizenzaenderung = nV;
      if (!this.documentData.lizenzaenderung) {
        const dateFormat = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        };
        this.documentData.installDate = new Date(
          this.geplantesInstallDate
        ).toLocaleDateString(navigator.language, dateFormat);
      }
    }
  },
  mounted: function() {
    if (
      this.$route.params.process != this.process ||
      this.license === undefined
    ) {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.ManualDocumentOverviewRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
  },
  methods: {
    updateVerkaufspreisGesamt: function() {
      this.documentData.verkaufspreisGesamt = String(
        parseFloat(this.documentData.verkaufspreisOrt.replace(",", ".")) +
          parseFloat(this.documentData.verkaufspreisAerzte.replace(",", "."))
      );
    },
    updateMonatlicheGesamt: function() {
      this.documentData.monatlicheSoftwarepflegeGesamtNeu = String(
        parseFloat(
          this.documentData.monatlicheSoftwarepflegePraxen.replace(",", ".")
        ) +
          parseFloat(
            this.documentData.monatlicheSoftwarepflegeAerzte.replace(",", ".")
          ) +
          parseFloat(
            this.documentData.monatlicheSoftwarepflegeSelektivvertraege.replace(
              ",",
              "."
            )
          ) +
          parseFloat(
            this.documentData.monatlicheSoftwarepflegePruefmodule.replace(
              ",",
              "."
            )
          )
      );
    },
    computeMwst: function() {
      this.documentData.monatlicheSoftwarepflegeMwst = String(
        Math.round(
          19 *
            parseFloat(
              this.documentData.monatlicheSoftwarepflegeNetto.replace(",", ".")
            )
        ) / 100
      );
      this.documentData.monatlicheSoftwarepflegeBrutto = String(
        parseFloat(
          this.documentData.monatlicheSoftwarepflegeNetto.replace(",", ".")
        ) +
          parseFloat(
            this.documentData.monatlicheSoftwarepflegeMwst.replace(",", ".")
          )
      );
    },
    createDocument: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("startLoading");
        const documentData = this.documentData;
        trimObjectValues(documentData);
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.order.CreateDocumentRequestEvent",
          taskId: this.$route.params.task,
          processId: this.$route.params.process,
          documentData: documentData
        });
      }
    }
  }
};
</script>
